import { useTransactionCalculationListSuspense } from "gen/endpoints/transactions/transactions";
import { TransactionCalculationData } from "gen/model/transactionCalculationData";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectOption } from "shared/components/input/select/SelectOption";

export interface TransactionCalculationSelectProps {
  fundFamilyId: string;
  name: string;
  calculationIdsToIgnore?: string[];
}

export const TransactionCalculationSelect: React.FC<
  TransactionCalculationSelectProps
> = ({ fundFamilyId, name, calculationIdsToIgnore }) => {
  const { t } = useTranslation(["allocation", "common"]);

  const { data: transactionCalculations } =
    useTransactionCalculationListSuspense(fundFamilyId, undefined, {
      query: {
        select: useCallback(
          (data: TransactionCalculationData[]) =>
            data.filter(
              (transactionCalculation) =>
                !calculationIdsToIgnore?.includes(transactionCalculation.id),
            ),
          [calculationIdsToIgnore],
        ),
      },
    });

  return (
    <FormSelect name={name} title={t("allocation:transactionCalculation")}>
      {transactionCalculations.map((transactionCalculation) => (
        <SelectOption
          key={transactionCalculation.id}
          value={transactionCalculation.id}
        >
          {transactionCalculation.name}
        </SelectOption>
      ))}
    </FormSelect>
  );
};
